












































































































































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  FETCH_REPLACEMENT_DISPOSITION_LIST,
  LOAD_ABSENCE_REASON_LIST
} from '@/store/action-types'
import { AbsenceReason } from '@/model/absences/AbsenceReason'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'
import DispositionRepresentativeDialog from '@/components/disposition/DispositionRepresentativeDialog.vue'
import { Replacement } from '@/model/disposition/Replacement'
import { ReplacementDispositionResponse } from '@/types/service-response'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'

interface STVSpecification {
  id: number
  name: string
}

interface AddressItem {
  id: string
  label: string
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  tableHeight: string
  showActive: boolean
  loading: boolean
  substitutionList: Replacement[]
  addressList: AddressItem[]
  showDialog: boolean
  currentSelectedRowData: Replacement | undefined

  STVSpecificationList: STVSpecification[]
  selectedSTVSpecification: STVSpecification | undefined
  isDateInputActivate: boolean
  dateFromFormatted: string
  dateFrom: string
  menuFrom: boolean
  dateToFormatted: string
  dateTo: string
  menuTo: boolean
  dateRules: Function[]
  selectedDateFrom: string
  selectedDateTo: string
  absenceReasonList: AbsenceReason[]
  selectedAbsenceReason: any[]
  selectedAddress: string
  selectedCleaningEmployee: number | null


  headers: any[]
  gridData: Replacement[]
  filteredGridData: Replacement[]
  overlayNoRowsTemplate: string
  currentSelectedRowList: Replacement[]
}

export default Vue.extend({
  name: 'DispositionRepresentative',

  components: {
    ProgressCircular,
    DispositionRepresentativeDialog
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      tableHeight: '',
      showActive: true,
      loading: false,
      substitutionList: [],
      addressList: [],
      showDialog: false,
      currentSelectedRowData: undefined,

      STVSpecificationList: [
        {id: 1, name: 'STV immer'},
        {id: 2, name: 'STV nie'},
        {id: 3, name: 'STV nach Absprache'},
        {id: 4, name: 'STV per Brief'}
      ],
      selectedSTVSpecification: undefined,
      isDateInputActivate: false,
      dateFromFormatted: '',
      dateFrom: '',
      menuFrom: false,
      dateToFormatted: '',
      dateTo: '',
      menuTo: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string) => {
          return value.length !== 10 ? 'Falsche Datum.' : true
        }
      ],
      selectedDateFrom: '',
      selectedDateTo: '',
      absenceReasonList: [],
      selectedAbsenceReason: [],
      selectedAddress: '',
      selectedCleaningEmployee: null,


      headers: [
        { text: this.$t('disposition.clerkIn').toString(), value: 'addressEmployee', align: 'start', groupable: false }
      ],
      gridData: [],
      filteredGridData: [],
      overlayNoRowsTemplate: this.$t('errors.noRowsToShow').toString(),
      currentSelectedRowList: []
    }
  },

  watch: {
    dateFromFormatted (newVal: string): void {
      if(newVal) {
        this.dateFrom = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
        const form: any = this.$refs['form1']
        if(newVal.length === 10 && form.validate()) {
          this.onFromValueChange(newVal)
        }
      }
    },

    dateToFormatted (newVal: string): void {
      if(newVal) {
        this.dateTo = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
        const form: any = this.$refs['form2']
        if(newVal.length === 10 && form.validate()) {
          this.onToValueChange(newVal)
        }
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    setShowButtonIcon (): string {
      if(this.showActive) {
        return 'visibility_off'
      } else {
        return 'visibility'
      }
    },

    isActivateDisabled (): boolean {
      return this.currentSelectedRowList.length === 0
    },

    isDeactivateDisabled (): boolean {
      return this.currentSelectedRowList.length === 0
    }
  },

  methods: {
    customFilter (item: Replacement, queryText: string): boolean {
      const textOne = item.fullName.toLowerCase()
      const textTwo = item.shortName.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
    },

    onShowSubstitution (): void {
      this.showActive = !this.showActive
      this.selectedSTVSpecification = undefined
      this.selectedAddress = ''
      this.isDateInputActivate = false
      this.selectedDateFrom = ''
      this.selectedDateTo = ''
      this.dateFromFormatted = ''
      this.dateToFormatted = ''
      this.selectedAbsenceReason = []
      this.selectedCleaningEmployee = null
      this.deselectAll()
      this.currentSelectedRowList = []
      const form1: any = this.$refs['form1']
      form1.resetValidation()
      const form2: any = this.$refs['form2']
      form2.resetValidation()
      this.fetchData()
    },

    onDateFromChange (date: string): void {
      this.dateFromFormatted = moment(date).format('DD.MM.YYYY')
      this.onFromValueChange(this.dateFromFormatted)
    },

    onFromValueChange (value: string): void {
      this.selectedDateFrom = value
    },

    onFromFocus (): void {
      setTimeout(() => {
        if(!this.menuFrom) {
          this.menuFrom = true
        }
      }, 100)
    },

    onFromBlur (): void {
      setTimeout(() => {
        if(this.menuFrom) {
          this.menuFrom = false
        }
      }, 100)
    },

    onDateToChange (date: string): void {
      this.dateToFormatted = moment(date).format('DD.MM.YYYY')
      this.onToValueChange(this.dateToFormatted)
    },

    onToValueChange (value: string): void {
      this.selectedDateTo = value
    },

    onToFocus (): void {
      setTimeout(() => {
        if(!this.menuTo) {
          this.menuTo = true
        }
      }, 100)
    },

    onToBlur (): void {
      setTimeout(() => {
        if(this.menuTo) {
          this.menuTo = false
        }
      }, 100)
    },

    onFilterClick () {
      this.currentSelectedRowData = undefined
      this.currentSelectedRowList = []
      this.deselectAll()

      this.filteredGridData = _.cloneDeep(this.gridData)

      if(this.selectedSTVSpecification) {
        this.filteredGridData = this.filteredGridData.filter((item: Replacement) => item.STVSpecification === this.selectedSTVSpecification!.name)
      }

      if(this.selectedAddress) {
        this.filteredGridData = this.filteredGridData.filter((item: Replacement) => item.addressNumber === this.selectedAddress)
      }

      if(this.isDateInputActivate) {
        if(this.selectedDateFrom && this.selectedDateTo) {
          this.filteredGridData = this.filteredGridData.filter((item: Replacement) => {
            if(moment(item.dateFrom).isSameOrAfter(moment(this.selectedDateFrom, 'DD.MM.YYYY')) && moment(item.dateFrom).isSameOrBefore(moment(this.selectedDateTo, 'DD.MM.YYYY'))) {
              return true
            } else if(moment(item.dateTo).isSameOrAfter(moment(this.selectedDateFrom, 'DD.MM.YYYY')) && moment(item.dateTo).isSameOrBefore(moment(this.selectedDateTo, 'DD.MM.YYYY'))) {
              return true
            } else if(moment(item.dateFrom).isBefore(moment(this.selectedDateFrom, 'DD.MM.YYYY')) && moment(item.dateTo).isAfter(moment(this.selectedDateTo, 'DD.MM.YYYY'))) {
              return true
            } else {
              return false
            }
          })
        }
      }

      if(this.selectedAbsenceReason && this.selectedAbsenceReason.length > 0) {
        this.filteredGridData = this.filteredGridData.filter((item: Replacement) => this.selectedAbsenceReason.includes(item.absenceReason))
      }

      if(this.selectedCleaningEmployee) {
        this.filteredGridData = this.filteredGridData.filter((item: Replacement) => item.employeeId === this.selectedCleaningEmployee)
      }

    },

    getFormattedDate (date: string): string {
      return moment(date).format('DD.MM.YYYY')
    },

    rowClick (event: MouseEvent, data: any): void {
      this.currentSelectedRowData = data.item
      this.showDialog = true
    },

    selectRow (item: Replacement, row: any): void {
      if (row.isSelected) {
        const index: number = this.currentSelectedRowList.indexOf(item)
        this.currentSelectedRowList.splice(index, 1)
        row.select(false)
      } else {
        this.currentSelectedRowList.push(item)
        row.select(true)
      }
    },

    closeDialog (): void {
      this.showDialog = false
    },

    deselectAll (): void {
      const table: any = this.$refs['table']
      if(table) {
        table.toggleSelectAll()
      }
    },

    async onActivateClick (): Promise<void> {
      try {
        this.loading = true
        const response = undefined //await this.$store.dispatch(CHANGE_SUBSTITUTION_STATUS, payload)
        if(response) {
          this.deselectAll()
          this.currentSelectedRowList = []
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchData()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.loading = false
      }
    },

    async onDeactivateClick (): Promise<void> {
      /*let payload: ChangeSubstitutionPayload = {
        action: 'Disable',
        data: this.currentSelectedRowList.map((item: Replacement) => {
          return { RowID: item.id, NSchritt: item.nextAction, STVVorgabe: item.STVSpecification }
        })
      }*/

      try {
        this.loading = true
        const response = undefined //await this.$store.dispatch(CHANGE_SUBSTITUTION_STATUS, payload)
        if(response) {
          this.deselectAll()
          this.currentSelectedRowList = []
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchData()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.loading = false
      }
    },

    async fetchData (): Promise<void> {
      this.loading = true
      try {
        const response: ReplacementDispositionResponse = await this.$store.dispatch(FETCH_REPLACEMENT_DISPOSITION_LIST, this.showActive)
        if (!response.IsError && response.Data) {
          this.gridData = Replacement.createFromResponse(response.Data)
          this.filteredGridData = _.cloneDeep(this.gridData)
          this.substitutionList = _.uniqBy(this.gridData, 'employeeId')
          this.addressList = _.uniqBy(this.gridData, 'addressName').map((item: Replacement) => {
            return {id: item.addressNumber, label: item.addressLabel}
          })
        }
        this.onFilterClick()
      } catch {
      } finally {
        this.loading = false
      }
    },

    async fetchAbsenceReason (): Promise<void> {
      const data: AbsenceReason[] = await this.$store.dispatch(LOAD_ABSENCE_REASON_LIST)
      this.absenceReasonList = _.sortBy(data, [function(o) { return o.description.toLocaleLowerCase(); }])
    },

    onResize (): void {
      if(this.$refs.toolbar && this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.toolbar as HTMLElement).clientHeight + (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 150px - ${height}px)`
        } else {
          this.tableHeight = '500px'
        }
      } else {
        this.tableHeight = '500px'
      }
    }

  },

  mounted () {
    this.fetchData()
    this.fetchAbsenceReason()
  }
})
